import { useContext } from 'react';

import AgoraContext from './context';

const useAgora = () => useContext(AgoraContext);

export default useAgora;
